import { Switchboard } from "../../lib/events";
import { ThematicLayer } from "../layers/server/ThematicLayer";
import $ from 'jquery';
export class ThematicLayerBox {
    constructor(opts) {
        this.header = $();
        this.body = $();
        this.layers = [];
        this.broadcaster = Switchboard.get_emitter("THEMATIC");
        this.render_index = opts.render_index;
        this.ui_index = opts.ui_index;
    }
    add_layers(layers) {
        this.layers = layers.filter(this.filter);
        this.build_ui();
    }
    filter(l) {
        return l instanceof ThematicLayer;
    }
    build_ui() {
        if (this.layers.length == 0) {
            this.header = $('<span/>');
            return $('<div class="layerType thematic"></div>');
        }
        this.header = $('<div class="header">Thematic</div><hr class="layerbox-hr" />');
        this.header.append(this.construct_opacity_select(this.layers));
        const $thematicDiv = $('<div class="layerType thematic"></div>');
        this.layers.forEach(layer => {
            layer.ui
                .map(ui => {
                ui.find(":input").on('click', (_) => this.broadcaster.emit('action', this.layers.filter(l => l.visible).length));
                ui.append(layer.legend_ui);
                return ui;
            })
                .map(ui => $thematicDiv.append(ui));
        });
        this.body = $thematicDiv;
    }
    construct_opacity_select(layers) {
        const select = $('<select id="thematic-opacity-select" style="float:right; font-weight:normal" name="noname02" title="Select Transparency Level"></select>');
        const range = Array.from(Array(11).keys()).reverse();
        let default_opacity = 0;
        let first_thematic_layer = layers[0];
        default_opacity = first_thematic_layer.parsed_opacity;
        default_opacity *= 100;
        const options = range.map(value => value * 10).map(value => $(`<option value="${value / 100}" ${value === default_opacity ? "selected" : ""} title="${value}% Transparency">${value}</option>`));
        for (let opt of options) {
            select.append(opt);
        }
        select.on('change', (e) => {
            layers.forEach(l => {
                l.opacity = parseFloat(e.target.value);
            });
            select.prop('value', e.target.value);
        });
        return select;
    }
}
